import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { AnalyseParticulierOutput } from '../model/rule/analyse-particulier-output';
import { AnalyseParticulierInput } from '../model/rule/analyse-particulier-input';
import { TauxFraisOutput } from '../model/rule/taux-frais-output';
import { TauxFraisInput } from '../model/rule/taux-frais-input';

@Injectable({
    providedIn: 'root'
  })
  export class RuleParticulierService{

    constructor(private _restClientService : RestClientService) 
    {}

        
    ruleTauxFrais(tauxFraisInput : TauxFraisInput) {
        return  this._restClientService.save<TauxFraisOutput>('rule-particulier/taux-frais', tauxFraisInput);
    }
    
    ruleAnalyseCreditParticulier(analyseParticulierInput : AnalyseParticulierInput) {
        return  this._restClientService.save<AnalyseParticulierOutput>('rule-particulier/simulateur', analyseParticulierInput);
    }
    
    
}      

    